export default "__VITE_ASSET__Bwc5aJMY__"